import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import {
  filterByName,
  filterByState,
} from '../../../store/features/stationSlice';
import { useLocation } from 'react-router-dom';

const SelectContainer = styled.div`
  z-index: 10;
  min-width: 160px;
  position: absolute;
  top: 21px;
  right: 25px;
  display: ${(props) => (props.moveSearcbar ? 'block' : 'none')};

  @media (max-width: 875px) {
    display: none;
  }
`;

const SelectBar = ({ inputRef, moveSearcbar = false }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const selectRef = useRef(null);

  const [selectedOption, setSelectedOption] = useState({
    value: '',
    label: 'Filtrar',
  });

  useEffect(() => {
    let currentPathName = window.location.pathname.split('/')[1];
    if (currentPathName.includes('gestion-administrador')) {
      selectRef.current.state.value = { label: 'Filtrar', value: '' };
      dispatch(filterByName(''));
      dispatch(filterByState(''));
    }
  }, [location]);

  const options = [
    { value: '', label: 'Todos' },
    { value: 'activo', label: 'Activo' },
    { value: 'inactivo', label: 'Inactivo' },
  ];

  const styles = {
    option: (provided, state) => ({
      ...provided,
      cursor: 'pointer',
      fontSize: '13.333px',
      fontFamily: 'inherit',
      color: state.isSelected ? '#323637' : '#323637',
      backgroundColor: state.isSelected ? '#E6E8E8' : '#F2F3F3',
    }),
    menu: (provided, state) => ({
      ...provided,
      margin: 0,
      border: 0,
      outline: 0,
      backgroundColor: '#F2F3F3',
      borderRadius: '0 0 5px 5px',
      fontSize: '13.333px',
      fontFamily: 'inherit',
      color: '#323637',
    }),
    control: (provided, state) => ({
      ...provided,
      backgroundColor: '#F2F3F3',
      borderRadius: 0,
      border: 0,
      outline: 0,
      fontSize: '13.333px',
      fontFamily: 'inherit',
      color: '#323637',
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      backgroundColor: '#F2F3F3',
      fontSize: '13.333px',
      fontFamily: 'inherit',
      color: '#323637',
      cursor: 'pointer',
    }),
    dropdownIndicator: (provided, state) => ({
      ...provided,
      cursor: 'pointer',
    }),
  };

  const handleSelect = (event) => {
    let { label, value } = event;
    dispatch(filterByState(event.value));
    setSelectedOption({ label, value });
  };

  return (
    <SelectContainer moveSearcbar={moveSearcbar}>
      <Select
        ref={selectRef}
        onChange={(e) => handleSelect(e)}
        defaultValue={selectedOption}
        label="Filtrar"
        options={options}
        styles={styles}
      />
    </SelectContainer>
  );
};

export default SelectBar;
